export enum NoteType {
  LESSON_PLAN = "LESSON_PLAN",
  GOALS = "GOALS",
  STIMULUS = "STIMULUS",
  LOGISTICS = "LOGISTICS",
  WHITEBOARD_BRIEF = "WHITEBOARD_BRIEF",
  OTHER = "OTHER",
}
